"use client";

import { useRouter } from "next/router";
import { useEffect } from "react";

declare global {
  interface Window {
    Termly?: {
      initialize: () => void;
    };
  }
}

// Re-runs Termly's initialization after a client-side navigation.
//
// The resource blocker itself is loaded once, synchronously, as the first
// script in <head> by pages/_document.tsx -- see the comment there for why it
// has to be first and why it cannot live here. _document only renders on a full
// page load, though, so this component covers the other half: it lives in
// _app.tsx, survives client-side route changes, and tells Termly to re-scan the
// freshly rendered page.
export default function TermlyRouteSync(): null {
  const router = useRouter();
  // asPath carries resolved dynamic segments and the query string; the hash is
  // dropped so an in-page anchor does not trigger a pointless re-init.
  const route = router.asPath.split("#")[0];

  useEffect(() => {
    if (typeof window === "undefined" || !window.Termly) return;
    try {
      window.Termly.initialize();
    } catch (e) {
      console.warn("Error initializing Termly:", e);
    }
  }, [route]);

  return null;
}
